import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Character } from "../../../types";
import { cn } from "@/lib/utils";

type CharacterInputFieldProps = {
  character: Character;
  index: number;
  value: string;
  onNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
};

const CharacterInputField: React.FC<CharacterInputFieldProps> = ({
  character,
  index,
  value,
  onNameChange,
  className,
}) => {
  return (
    <div
      className={cn("flex justify-center items-stretch max-w-full", className)}
    >
      <Label
        variant="numbered"
        htmlFor={`char-${character.id}`}
      >
        {index + 1}
      </Label>
      <Input
        variant="character"
        inputWidth="flexible"
        disabled={character.meta.locked}
        id={`char-${character.id}`}
        minLength={1}
        maxLength={30}
        autoComplete="off"
        name={String(character.id)}
        type="text"
        value={value}
        onChange={onNameChange}
        required
      />
    </div>
  );
};

export default CharacterInputField;
